import { useState } from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import apiInstance from "../apiConfig/apiinstance";
import { TokenManager } from "../apiConfig/apiinstance";
import axios from "axios";
import BaseUrl from "../BaseUrl";

export default function LoginModal(props) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();

    const payload = {
      username,
      password,
    };

    setLoading(true);
    try {
      const res = await axios.post(
        `${BaseUrl()}/api/auth/v1/auth/login/`,
        payload
      );
      const { data } = res;
      if (data?.status === 200) {
        TokenManager.setTokens(
          data?.data?.tokens?.access,
          data?.data?.tokens?.refresh
        );
        // navigate("/");
        const redirectPath = localStorage.getItem("redirectAfterLogin");
        if (redirectPath) {
          localStorage.removeItem("redirectAfterLogin");
          window.location.href = redirectPath;
        } else {
          window.location.reload();
        }
        window.dispatchEvent(new Event("tokenUpdated"));
        props.onHide();
      }

      console.log("res in login modal", res);

      // setError(res?.message);
    } catch (error) {
      console.log("error in login modal", error);

      setError(
        error?.response?.data?.message ||
          error?.message ||
          "Invalid Credentials"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      {...props}
      //   size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      dialogClassName="modal-30w"
      backdrop="static"
      keyboard={false}
      backdropClassName="blur_backdrop"
      className="font-sans"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Login</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="flex justify-center items-center py-8">
            <ClipLoader color="#3498db" loading={loading} size={50} />
            <span className="ml-3 text-gray-600">Logging in...</span>
          </div>
        ) : (
          <form onSubmit={handleLogin}>
            {error && (
              <div className="mb-3 text-red-600 text-center text-sm font-semibold">
                {error}
              </div>
            )}
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => {
                setUsername(e.target.value);
                setError("");
              }}
              style={{ fontFamily: "sans-serif" }}
              required
              autoFocus
              className="w-full mb-4 p-3 border border-gray-300 rounded"
            />
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setError("");
                }}
                required
                style={{ fontFamily: "sans-serif" }}
                className="w-full mb-4 p-3 border border-gray-300 rounded pr-10"
              />
              <span
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-[50%] -translate-y-5 text-gray-600 cursor-pointer"
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
            <button
              type="submit"
              disabled={loading}
              className={`w-full bg-blue-600 text-white py-3 rounded hover:bg-blue-700 transition disabled:bg-gray-400 font-sans`}
            >
              Login
            </button>

            {/* <p className="text-center mt-4 text-gray-600">
              Forgot your password ?{" "}
              <Link
                to="/forgot-password"
                className="text-blue-600 hover:underline"
              >
                Forgot Password
              </Link>
            </p> */}
            <p className="text-center mt-2 text-gray-600">
              <Link
                to="/auth/reset-password/"
                className="text-blue-600 hover:underline"
              >
                Change System Password
              </Link>
            </p>
            {/* <p className="text-center text-gray-600">
              Don't have an account ?{" "}
              <Link to="/register" className="text-blue-600 hover:underline">
                Register
              </Link>
            </p> */}
          </form>
        )}
      </Modal.Body>
    </Modal>
  );
}
